// extracted by mini-css-extract-plugin
module.exports = {"loadingImage":"Loading_loadingImage__kdQC_","rotation":"Loading_rotation__3iuP_"};